var map = {
	"./1.png": 3127,
	"./2.png": 6716,
	"./3.png": 2165,
	"./4.png": 5658,
	"./5.png": 6883,
	"./bacg.png": 65,
	"./beijing.png": 9716,
	"./pa4.png": 2117,
	"./tx.png": 8344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 767;